import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';

export interface AlertRecipient {
  userGuid: string;
  userName: string;
  email: string;
  acknowledgmentRequired: boolean;
  acknowledgedAt: string | null;
  acknowledgmentId: string | null;
}

const base = ['alert-recipients'] as const;

export const alertRecipientsKeys = {
  base,
  byEventInstanceId: (eventInstanceId: string) =>
    [...base, eventInstanceId] as const,
} as const;

// Fetch recipients for an alert event instance
export const useAlertRecipients = (eventInstanceId: string) => {
  const queryOptions: UseQueryOptions<AlertRecipient[], Error> = {
    queryKey: alertRecipientsKeys.byEventInstanceId(eventInstanceId),
    queryFn: async () => {
      const response = await axios.get(
        `${config.apiGateway.dgptAlerts}/recipients/event/${eventInstanceId}`
      );
      return response.data;
    },
    enabled: !!eventInstanceId,
  };

  return useQuery<AlertRecipient[], Error>(queryOptions);
};
